import { render, staticRenderFns } from "./ModuloConsultorio.vue?vue&type=template&id=f64f19f4&scoped=true&"
import script from "./ModuloConsultorio.vue?vue&type=script&lang=js&"
export * from "./ModuloConsultorio.vue?vue&type=script&lang=js&"
import style0 from "./ModuloConsultorio.vue?vue&type=style&index=0&id=f64f19f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64f19f4",
  null
  
)

export default component.exports